import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from './';


class Portal extends Component {
  constructor(props) {
    super(props);

    this.rootSelector = document.getElementById('modal-root');
    this.container = document.createElement('div');
  }

  componentDidMount() {
    this.rootSelector.appendChild(this.container);
  }

  componentWillUnmount() {
    this.rootSelector.removeChild(this.container);
  }

  render() {
    return ReactDOM.createPortal(<Modal {...this.props} />, this.container);
  }
}

export default Portal;
